module.exports = __webpack_public_path__ + "img/chevron-up-alt.bee3226d.svg";